export default "__VITE_ASSET__79164650__"